module.exports = __webpack_public_path__ + "img/logo32.e467f2c6.png";